// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonPlaceholders = {
  enter: "Please enter",
  select: "Please select",
} as const;
